<bn-loading-overlay></bn-loading-overlay>
<div class="row">
  <div class="col">
    <h3>Detalhes da cobrança <small class="text-muted">(#ID: {{cobranca?.id}})</small></h3>
  </div>
  <div class="col-auto">
    <button class="btn btn-primary" type="button" (click)="voltar()">Voltar</button>
    <button *ngIf="podeReemitirCobranca" [disabled]="cobranca?.tipoCobranca != '1' || cobranca?.estado?.id != 3 
            || cobranca?.indicadorReemissaoSolicitada"
        class="btn btn-light" type="button" (click)="reemitirCobranca()">Reemitir cobrança</button>
  </div>
</div> 

<div class="row" *ngIf="cobranca">
    <div class="bn-form-group col-md-3">
        <label><b>Agente Financeiro</b></label>
        <input type="text" class="form-control" name="nomeAgenteFinanceiro" [(ngModel)]="cobranca.nomeAgenteFinanceiro" disabled />
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Código da Cobrança</b></label>
        <input type="text" class="form-control" name="codigoCobranca" [(ngModel)]="cobranca.codigoCobranca" disabled />
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Tipo de Cobrança</b></label>
        <input type="text" class="form-control" name="codigoCobranca" [(ngModel)]="labelTipoCobranca" disabled />
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Data de Emissão</b></label>
        <bn-datepicker name="dataEmissaoDaFicha" [(ngModel)]="cobranca.dataEmissaoDaFicha" disabled></bn-datepicker>
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Data de Vencimento</b></label>
        <bn-datepicker name="dataVencimentoDaFicha" [(ngModel)]="cobranca.dataVencimentoDaFicha" disabled></bn-datepicker>
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Data de Pagamento</b></label>
        <bn-datepicker name="dataPagamentoDaFicha" [(ngModel)]="cobranca.dataPagamentoDaFicha" disabled></bn-datepicker>
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Valor devido em SELIC</b></label>
        <input type="text" class="form-control moeda" name="valorDevidoEmSELIC" [(ngModel)]="cobranca.valorDevidoEmSELIC" bnMask="MOEDA.5" [simboloMoeda]="''" disabled />
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Valor pago em SELIC</b></label>
        <input type="text" class="form-control moeda" name="valorPagoEmSELIC" [(ngModel)]="cobranca.valorPagoEmSELIC" bnMask="MOEDA.5" [simboloMoeda]="''" disabled />
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Valor pago em reais</b></label>
        <input type="text" class="form-control moeda" name="valorPagoEmReais" [(ngModel)]="cobranca.valorPagoEmReais" bnMask="MOEDA" disabled />
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Estado</b></label>
        <input type="text" class="form-control" name="nomeEstado" [value]="cobranca.estado?.nomeEstado" disabled />
    </div>
    <div class="bn-form-group col-md-3">
        <label><b>Boleto (PDF)</b></label>
        <div class="input-group">
            <input type="text" class="form-control cursor-pointer" (click)="exportarBoleto(cobranca)" name="nomeEstado" value="Boleto_{{cobranca.codigoCobranca}}.pdf" disabled />
            <span class="input-group-text cursor-pointer" (click)="exportarBoleto(cobranca)"><i class="fa fa-download"></i></span>
        </div>
    </div>

    <div class="bn-form-group col-md-3">
        <label><b>Extrato</b></label>
        <div class="input-group">
            <input type="text" class="form-control cursor-pointer" (click)="exportarExtrato(cobranca)" name="nomeEstado" value="{{cobranca.nomeExtratoCobranca}}" disabled />
            <span class="input-group-text cursor-pointer" (click)="exportarExtrato(cobranca)"><i class="fa fa-download"></i></span>
        </div>
    </div>

    <div class="bn-form-group col-md-3" *ngIf="cobranca && cobranca.nomeAnexoCobranca">
        <label><b>Anexo</b></label>
        <div class="input-group">
            <input type="text" class="form-control cursor-pointer" (click)="exportarAnexo(cobranca)" name="nomeEstado" value="{{cobranca.nomeAnexoCobranca}}" disabled />
            <span class="input-group-text cursor-pointer" (click)="exportarAnexo(cobranca)"><i class="fa fa-download"></i></span>
        </div>
    </div>

    <div class="bn-form-group col-md-3" *ngIf="cobranca?.estado?.id == 3">
        <label><b>Reemissão solicitada</b></label>
        <input class="form-check checkbox-gigante" type="checkbox" name="indicadorReemissao"
            [(ngModel)]="cobranca.indicadorReemissaoSolicitada" disabled/>
    </div>
</div>

<ng-template #botoesConfirmacaoReeemissaoCobranca>
    <button class="btn btn-default" (click)="cancelarReemissao()">Cancelar</button>
    <button class="btn btn-primary" (click)="reemitirCobranca()">Confirmar</button>
</ng-template>
  
<ng-template #mensagemConfirmacaoReemissaoCobranca>
    <div class="bn-form-group row">

        <p>As liberações/aditivos ou recuperações cobradas neste boleto serão transitadas para 'Aguardando emissão de
            cobrança' e um nova cobrança será gerada no processo noturno de hoje com esses elementos.</p>
        <label for="motivoReemissao"><b>Motivo para reemissão da cobrança</b></label>
        <textarea class="form-control" id="motivoReprovacao" name="motivoReemissao" maxlength="200" rows="3" [(ngModel)]="motivoReemissao" required></textarea>
    </div>
  </ng-template>